<template>
  <div>
    <protocol-header v-if="protocol"
                    :protocol="protocol"
                    :task="task"></protocol-header>
    
    <div class="row">
      <div class="col-12 mb-3">
        <financing-commitments-list :protocol="protocol"
                                    :editable="false"
                                    :editing="true"
                                    :financing-commitments="financingCommitments"></financing-commitments-list>
      </div>
      <div class="col-12 mb-3">
        <div class="card">
          <div class="card-header">
            <h2 class="card-title mb-0">Solicitud de eliminación de compromiso</h2>
          </div>
          <div class="card-body">
            <form id="formDeleteCommitment"
                  ref="formDeleteCommitment"
                  @submit.prevent=""
                  class="form">
              <div class="form-group mb-4">
                <label for="justification">Comentarios del comite:</label>
                <textarea id="justification"
                          name="justification"
                          rows="5"
                          placeholder="justificacion"
                          class="form-control"
                          disabled
                          v-model="task.taskable.last_dictum.comments"></textarea>
              </div>
              <div class="form-group mb-4">
                <label for="justification">Justificación: *</label>
                <textarea id="justification"
                          name="justification"
                          rows="5"
                          placeholder="Justificación"
                          class="form-control"
                          v-model="justification"></textarea>
              </div>
              <div class="form-group mb-4">
                <button type="submit"
                        class="btn btn-lg btn-primary mr-2"
                        id="btn-save">Enviar Solicitud
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <portal to="task-modals">
      <ok-cancel-dialog id="delete-commitment-modal"
                        ref="deleteCommitmentModal"
                        title="Solicitar eliminación de compromiso"
                        ok-button-text="Confirmar"
                        :disabled="saving"
                        :content="modalContent"
                        :ok-callback="deleteCommitment"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import 'jquery-validation'
  import ProtocolHeader from './commons/ProtocolHeader'
  import FinancingCommitmentsList from './FinancingCommitmentsList'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import { AlertManager } from '../utils/AlertManager'
  import { mapActions, mapGetters } from 'vuex'
  
  export default {
    name: 'RequestDeleteCommitment',
    components: {
      ProtocolHeader,
      FinancingCommitmentsList,
      OkCancelDialog,
    },
    props: {
      protocol: Object,
      task: Object,
    },
    data () {
      return {
        modalContent: '¿Esta seguro de enviar la solicitud?',
        justification: '',
        saving: false,
      };
    },
    methods: {
      ...mapActions({
        getFinancingCommitment: 'protocols/getFinancingCommitment',
        requestDeleteCommitment: 'protocols/requestDeleteCommitment',
        requestDeleteFinancingExtensionCommitment: 'protocols/requestDeleteFinancingExtensionCommitment',
      }),
      async load () {
        await this.getFinancingCommitment({
          protocol: this.protocol.id,
          commitment: this.task.taskable_id
        })
      },
      async deleteCommitment () {
        this.saving = true

        const response  = this.task.type === 'amendment_extension' ?
          await this.requestDeleteFinancingExtensionCommitment({
            commitment: this.task.taskable_id,
            dictum: this.task.taskable.last_dictum.id,
            task: this.task.id,
            justification: this.justification,
          }) :
          await this.requestDeleteCommitment({
            commitment: this.task.taskable_id,
            dictum: this.task.taskable.last_dictum.id,
            task: this.task.id,
            justification: this.justification,
          })
      
        
        this.saving = false
        
        const { status, error, message } = response.data.data
        
        if(status === 'error') {
          AlertManager.error(error)
        }
        
        AlertManager.success(message)
        
        this.$emit('close-task')
      },
    },
    computed: {
      ...mapGetters({
        financingCommitments: 'protocols/financingCommitments',
      }),
    },
    async mounted () {
      const vm = this

      $(vm.$refs.formDeleteCommitment).validate({
        highlight: function(element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function(element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function(error, element) {
          error.addClass('invalid-feedback')
          error.insertAfter(element)
        },
        rules: {
          justification: {
            required: true,
          },
        },
        messages: {
          justification: {
            required: 'Escriba la justificación.',
          },
        },
        submitHandler (form) {
          $('#delete-commitment-modal').modal('show')
        },
      })

      await vm.load()
    },
  }
</script>
